import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Firebase configurations for different environments
const firebaseConfigs = {
  // Local emulator (Phase T UI tests): the demo- project id is emulator-only
  // by Firebase convention - real APIs reject it, so this config can never
  // reach production. Selected ONLY via REACT_APP_ENVIRONMENT=emulator.
  emulator: {
    apiKey: 'demo-api-key',
    authDomain: 'demo-lucky-claww.firebaseapp.com',
    projectId: 'demo-lucky-claww',
    storageBucket: 'demo-lucky-claww.appspot.com',
    messagingSenderId: '000000000000',
    appId: '1:000000000000:web:demo'
  },
  production: {
    apiKey: "AIzaSyAxN7nKZeDNpxd7AgjOGqjH0CLmDEmMx3w",
    authDomain: "lucky-claww-membership.firebaseapp.com",
    projectId: "lucky-claww-membership",
    storageBucket: "lucky-claww-membership.firebasestorage.app",
    messagingSenderId: "844941992838",
    appId: "1:844941992838:web:cdcab510ab911bcf160207"
  },
  staging: {
    apiKey: "AIzaSyAZZNKAjcwNP5HHiljTbLxAjm_8K2mCazg",
    authDomain: "lucky-claww-membership-test.firebaseapp.com",
    projectId: "lucky-claww-membership-test",
    storageBucket: "lucky-claww-membership-test.firebasestorage.app",
    messagingSenderId: "1025885365465",
    appId: "1:1025885365465:web:381e294cd86b957a4b8ac8"
  }
};

// Determine which environment to use
const getEnvironment = () => {
  // Check for explicit environment variable
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }

  // Check if running in development mode
  if (process.env.NODE_ENV === 'development') {
    return 'staging';
  }

  // Default to production
  return 'production';
};

const environment = getEnvironment();
const firebaseConfig = firebaseConfigs[environment];

console.log(`🔥 Firebase Environment: ${environment}`);
console.log(`🔥 Firebase Project: ${firebaseConfig.projectId}`);

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// Point the SDKs at the shared local emulator harness (see the website
// repo's test/emulator/README.md for ports) - emulator environment only.
if (environment === 'emulator') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9582', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8582);
}

// Configure Google provider for better popup handling
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export { auth, db, googleProvider, environment };
